import { useQuery } from '@tanstack/react-query';

import { listMenuPositions } from './api';

/** `enabled` holds the query until the customer picks a unit (several units, none chosen yet). */
export function useMenuPositions(operatingUnitId?: string, enabled = true) {
  return useQuery({
    queryKey: ['menu-positions', operatingUnitId],
    queryFn: () => listMenuPositions(operatingUnitId),
    enabled,
  });
}
